import { APP_STORE_URL } from "@vahak/core/dist/constants/link";

export const COMPACT_APP_DOWNLOAD = {
    appStoreUrl: APP_STORE_URL,
    playStoreUrl: "https://6r7cz.app.link/googleplay",
    promoImages: {
        default: "homepage-v2/app-download-banner.png",
        hi: "homepage-v2/app-download-banner-hi.png"
    }
} as const;

export function getCompactAppDownloadBannerImage(locale?: string) {
    return locale === "hi" ? COMPACT_APP_DOWNLOAD.promoImages.hi : COMPACT_APP_DOWNLOAD.promoImages.default;
}
